import { createEntityMutation } from '../../createEntityMutation';
import {
  ConvertibleService,
  type Wealthlane_CapTable_Dtos_Convertible_CreateConvertibleDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

export type CreateConvertibleDto = Wealthlane_CapTable_Dtos_Convertible_CreateConvertibleDto;

export const usePostConvertible = createEntityMutation<unknown, CreateConvertibleDto>({
  mutationFn: (payload) => ConvertibleService.postApiCapTableApiAppConvertible(payload),
  invalidateKeys: ['dt-v2-page'],
});
